var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormRender',{attrs:{"Service":_vm.Service,"form":_vm.form}},[_c('FormInput',{attrs:{"field":_vm.formFields.display_name},model:{value:(_vm.form.display_name),callback:function ($$v) {_vm.$set(_vm.form, "display_name", $$v)},expression:"form.display_name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }